(function () {
    'use strict';

    var wizardStepPrevious = {
        transclude: true,
        templateUrl: 'app/components/wizard/wizard-step-previous.html',
        controller: wizardStepPreviousController,
        controllerAs: 'vm',
        require: {
            'parent': '^wizard'
        },
        bindings:{
            label: '@',
            formWizard: '='
        }
    }

    angular
        .module('completeAir')
        .component('wizardStepPrevious', wizardStepPrevious);

    function wizardStepPreviousController(){
        var vm = this;

        vm.$onInit = function(){
        }

        vm.disabledPrevious = function() {
            vm.parent.disabledPrevious();
        }

        vm.previousWizard = function() {
            vm.wizardStepCurrent = vm.parent.wizardStep - 1;
            vm.parent.previousWizard(vm.wizardStepCurrent);
        }
    }

})();

